import Box from "@memorang/ui/src/components/Box";
import { ProgressBar } from "@memorang/ui/src/components/ProgressBar/Default";
import { Appbar, type AppbarProps } from "react-native-paper";

type Props = {
	onBackAction?: () => void;
	rightAction?: React.ReactNode;
	progress?: number;
	showProgress?: boolean;
	maxWidth?: number;
} & Omit<AppbarProps, "children">;

const OnboardingAppBar = ({
	onBackAction,
	rightAction,
	style,
	progress = 0,
	showProgress = true,
	maxWidth,
	...rest
}: Props) => {
	// If back action exists, showBackAction = true, otherwise false
	const showBackAction = !!onBackAction;

	return (
		<Appbar.Header
			mode="center-aligned"
			{...rest}
			style={[
				{
					position: "relative",
				},
				style,
			]}
		>
			{showBackAction && <Appbar.BackAction onPress={onBackAction} />}

			<Appbar.Content
				title={
					showProgress ? (
						<Box width="100%" maxWidth={maxWidth}>
							<ProgressBar progress={progress} />
						</Box>
					) : (
						""
					)
				}
			/>
			{rightAction && rightAction}
		</Appbar.Header>
	);
};

export default OnboardingAppBar;
